/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  setIsLoading,
  setPortalUrl,
  showSubscriptionSuccess,
} from './subscriptions.actions';

interface SubscriptionsState {
  isLoading: boolean;
  showSubscriptionSuccess: boolean;
  portalUrl: string | undefined;
}

const initialState: SubscriptionsState = {
  isLoading: false,
  showSubscriptionSuccess: false,
  portalUrl: undefined,
};

// eslint-disable-next-line import/prefer-default-export
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(setIsLoading, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(setPortalUrl, (state, action) => {
    state.portalUrl = action.payload;
  });

  builder.addCase(showSubscriptionSuccess, (state, action) => {
    state.showSubscriptionSuccess = action.payload;
  });
});
